import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { OPTIONS } from "@/lib/onboardingOptions";
import ChipGrid from "./ChipGrid";

const transition = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };

export default function Step4Budget({ draft, setDraft, next, prev }) {
  const set = (f) => (v) => setDraft((d) => ({ ...d, [f]: v }));
  const canContinue = draft.budget_available && draft.funding_source;

  return (
    <motion.div
      data-testid="onboarding-step-4"
      key="step-4"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={transition}
      className="text-white"
    >
      <h2 className="text-[28px] font-extrabold leading-[1.1] tracking-tight md:text-[32px]">
        Money &amp; runway
      </h2>
      <p className="mt-2 text-[13px] text-white/55">
        Be honest — Ledger plans around the real numbers.
      </p>

      <div className="mt-6 space-y-6">
        <Group label="What budget do you currently have available?">
          <ChipGrid
            testIdPrefix="q-budget-available"
            options={OPTIONS.budget_available}
            value={draft.budget_available}
            onChange={set("budget_available")}
            columns={2}
          />
        </Group>

        <Group label="How are you funding the startup?">
          <ChipGrid
            testIdPrefix="q-funding-source"
            options={OPTIONS.funding_source}
            value={draft.funding_source}
            onChange={set("funding_source")}
            columns={2}
          />
        </Group>
      </div>

      <footer className="mt-8 flex items-center justify-between">
        <button
          type="button"
          data-testid="onboarding-step-back"
          onClick={prev}
          className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-white/60 hover:text-white"
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={2.4} />
          Back
        </button>
        <button
          type="button"
          data-testid="onboarding-step-continue"
          disabled={!canContinue}
          onClick={next}
          className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-[13px] font-bold text-black shadow-[0_10px_30px_-10px_rgba(255,255,255,0.5)] transition-opacity disabled:opacity-40"
        >
          Continue
          <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.6} />
        </button>
      </footer>
    </motion.div>
  );
}

function Group({ label, children }) {
  return (
    <div>
      <div className="eyebrow mb-2 text-white/55">{label}</div>
      {children}
    </div>
  );
}
